import { call, put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { webSocketService } from 'services/WebSocketService';
import { ActionType } from 'typesafe-actions';
import { cancelAllCardsAction, cancelAllCardsFailureAction } from 'data/reducers';

import { responseType } from 'constants/common';

export function* cancelAllCardsSaga({
  payload: { shiftManagerId },
}: ActionType<typeof cancelAllCardsAction>) {
  const { type, data } = yield call(() =>
    webSocketService.sendMessage({
      type: Notifications.CANCEL_ALL_CARDS,
      data: { shiftManagerId },
    }),
  );

  if (type === responseType.Error) {
    yield put(cancelAllCardsFailureAction(data));
  }
}
